import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { SocialSigninService } from '../../social-signin/social-signin.service';

@Component({
    standalone: false,
    selector: 'abs-reset-password-request',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.LOGIN.RESET_PASSWORD.TITLE' | translate">
            <ng-container *ngIf="!submitted; else confirmationMessage">
                <form [formGroup]="emailForm" (ngSubmit)="submit()" class="content">
                    <div class="form-row">
                        <ion-label>{{ 'GLOBAL.LOGIN.EMAIL' | translate }}</ion-label>
                        <ion-input type="email" formControlName="email"></ion-input>
                    </div>
                    <div class="buttons">
                        <ion-button type="submit" [disabled]="emailForm.invalid || submitting">
                            {{ 'GLOBAL.LOGIN.RESET_PASSWORD.SUBMIT' | translate }}
                        </ion-button>
                    </div>
                </form>
            </ng-container>
            <ng-template #confirmationMessage>
                <p class="content">{{ 'GLOBAL.LOGIN.RESET_PASSWORD.CHECK_EMAIL' | translate }}</p>
            </ng-template>
        </abs-page-layout>
    `
})
export class ResetPasswordRequestPage implements OnInit {
    submitting = false;
    submitted = false;

    emailForm = this.fb.group({
        email: this.fb.control('', [Validators.required, Validators.email])
    });

    constructor(
        private fb: UntypedFormBuilder,
        private socialSignin: SocialSigninService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        // route.queryParams, not route.snapshot.queryParams: components hosted by an
        // ion-router-outlet get Ionic's ActivatedRoute proxy, whose `snapshot` is only
        // reassigned in IonRouterOutlet.activateWith() and therefore freezes at construction.
        // The proxied observables stay live. Same defect that broke the settings shell (52bf5375).
        this.route.queryParams.subscribe((params) => {
            if (params['email']) {
                this.emailForm.patchValue({ email: params['email'] });
            }
        });
    }

    async submit() {
        if (this.emailForm.invalid) {
            return;
        }

        this.submitting = true;

        try {
            await this.socialSignin.requestPasswordReset(this.emailForm.value.email);
        } catch {
            // Deliberately swallowed: showing the same "check your email" message
            // regardless of outcome prevents using this form to enumerate registered emails.
        } finally {
            this.submitting = false;
            this.submitted = true;
        }
    }
}
